import { Layers } from "lucide-react";

// Brand mark for TCA DebitFlow.
// NOTE: user will supply a logo — to swap it in, set `logoUrl` and it will render
// the image instead of the fallback mark (also update /public/favicon).
const logoUrl = null;

export function Brand({ size = "md", showText = true, className = "", onDark = false }) {
  const dims = size === "lg" ? "h-11 w-11" : size === "sm" ? "h-8 w-8" : "h-9 w-9";
  const title = size === "lg" ? "text-2xl" : "text-lg";
  const textColor = onDark ? "text-white" : "text-slate-900 dark:text-slate-50";
  const accentColor = onDark ? "text-blue-400" : "text-blue-600 dark:text-blue-400";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      {logoUrl ? (
        <img src={logoUrl} alt="TCA DebitFlow" className={`${dims} rounded-lg object-contain`} />
      ) : (
        <div
          className={`${dims} rounded-lg ${onDark ? "bg-blue-600" : "bg-slate-900 dark:bg-blue-600"} flex items-center justify-center shadow-sm ring-1 ring-slate-900/10`}
        >
          <Layers className="h-1/2 w-1/2 text-white" strokeWidth={2.2} />
        </div>
      )}
      {showText && (
        <div className="leading-none">
          <span className={`font-display font-extrabold tracking-tight ${textColor} ${title}`}>
            TCA
            <span className={accentColor}> DebitFlow</span>
          </span>
        </div>
      )}
    </div>
  );
}
